import { render, staticRenderFns } from "./PlatformContractManagement.vue?vue&type=template&id=c537678a&scoped=true&"
import script from "./PlatformContractManagement.vue?vue&type=script&lang=js&"
export * from "./PlatformContractManagement.vue?vue&type=script&lang=js&"
import style0 from "./PlatformContractManagement.vue?vue&type=style&index=0&id=c537678a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c537678a",
  null
  
)

export default component.exports